import { useState } from 'react';

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { Button, Container } from '@mui/material';
import IconButton from '@mui/material/IconButton';

import Typescript from '@mui/material/Typography'

import Title from '../../components/Title'
import Text from '../../components/Text'

import icon_1 from '../../images/icones/einreichen/persönlich.png'
import icon_2 from '../../images/icones/einreichen/dropbox.png'
import icon_3 from '../../images/icones/einreichen/per_post.png'

import icon from '../../images/image.png'

import image1 from '../../images/symptoms/Fillodia_in_Calendula_officinalis.png'
import image2 from '../../images/symptoms/C_pinustaeda_iNaturalist.png'
import image3 from '../../images/symptoms/C_Steve_Collins_iNaturalist.png'
import image4 from '../../images/symptoms/Vergilbung.jpg'


function Symptome() {

  return (

    <Container className="pb-4 bgwhite">

      <Grid
        container
        flexDirection="row"
        justifyContent="flex-end"
        className="pt-2"
      >
        <Text
          variant="extrasmall"
          color="black"
          text="symptome_top">
        </Text>
      </Grid>

      <Grid container flexDirection="column" justifyContent="flex-start">

        <Title variant="big" text="symptome_title" color="orange" />
        <Text variant="normal" size="12pt" text="symptome_body" />

      </Grid>


      <Grid container flexDirection="row" justifyContent="center" alignContent="center" spacing={2} className="px-5">

        <Grid className="greenbox p-4"
          size={{ xs: 12, sm: 4, md: 3 }}
          >

          <div className="center">
            <Title variant="big" color="beige" text="symptome_box_1_title" />
            <Text variant="small" color="beige" text="symptome_box_1_text" />
          </div>
          <img src={image1} className="p-2"></img>

        </Grid>


        <Grid className="greenbox p-4"
          size={{ xs: 12, sm: 4, md: 3 }}
          >

          <div className="center">
            <Title variant="big" color="beige" text="symptome_box_2_title" />
            <Text variant="small" color="beige" text="symptome_box_2_text" />
          </div>
          <img src={image2} className="p-2"></img>

        </Grid>

        <Grid className="greenbox p-4"
          size={{ xs: 12, sm: 4, md: 3 }}
          >

          <div className="center">
            <Title variant="big" color="beige" text="symptome_box_3_title" />
            <Text variant="small" color="beige" text="symptome_box_3_text" />
          </div>
          <img src={image3} className="p-2"></img>

        </Grid>

        <Grid className="greenbox p-4"
          size={{ xs: 12, sm: 4, md: 3 }}
          >

          <div className="center">
            <Title variant="big" color="beige" text="symptome_box_4_title" />
            <Text variant="small" color="beige" text="symptome_box_4_text" />
          </div>
          <img src={image4} className="p-2"></img>

        </Grid>

      </Grid>


    </Container >
  );
}

export default Symptome;
